import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PSDocument } from '../model/document.interface';

@Component({
  selector: 'shared-dp-page-preview-separator',
  imports: [CommonModule],
  templateUrl: './page-preview-separator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagePreviewSeparatorComponent {
  readonly document = input.required<PSDocument>();
  readonly splitIndex = input.required<number>();

  readonly pageSeparatorLabelTemplate =
    input<TemplateRef<{ $implicit: PSDocument; splitIndex: number }>>();
}
